import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { cellNotFilter, formatDateWithTimeCell, hasAllPermissions, hasPermission, useCheckPermissions, useTableFilter, useTableServerSideFiltering } from '@/shared';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { PermissionsEnum } from '@/auth/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';
import { ICategoriaIncidentes } from '@/shared/interfaces/erp/tickets-soporte-clientes';
import { useFetchCategoriaIncidentes, useUpdateCategoriaIncidentes } from '@/shared/actions/erp/categoria-incidentes';

const returnUrl = '/tickets-soporte-cliente/categoria-incidente';

export interface CategoriaIncidentePageInterface { }

const CategoriaIncidentePage: React.FC<CategoriaIncidentePageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_categoria_producto)

  const navigate = useNavigate();
  /* const updSate = useUpdateCategoryProduct({
    enableRedirect: false,
  }); */
  const updSate = useUpdateCategoriaIncidentes({
    enableRedirect: false
  })
  ///* global state
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );
  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,

  } = useTableFilter();
  const { pageIndex } = pagination;
  //
  const{columnFilters, setColumnFilters, filterObject}=useTableServerSideFiltering()

  ///* fetch data
  const {
    data: categoriaIncidentesPagingRes,
    isLoading,
    isRefetching,
  } = useFetchCategoriaIncidentes({
    page: pageIndex + 1,
    nombre: searchTerm,
    ...filterObject,
    filterByState:false
  });

  ///* mutations


  ///* handlers
  const onEdit = (original: ICategoriaIncidentes) => {
    navigate(`${returnUrl}/editar/${original.id_categoria_incidencia}`);
  };

  ///* columns
  const columns = useMemo<MRT_ColumnDef<ICategoriaIncidentes>[]>(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Código',
        size: 120,
      },
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 300,
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripción'
      }, 
      {
        accessorKey: 'departamento_nombre',
        header: 'Departamento'
      },
      {
        ...cellNotFilter,
        accessorKey:'fecha_creacion',
        header:'Fecha Creación',
        size:200,
        Cell:({row})=>formatDateWithTimeCell(row, 'fecha_creacion')
      },
      {
        ...cellNotFilter,
        accessorKey:'fecha_modificacion',
        header:'Fecha Modificación',
        size: 200,
        Cell:({row})=>formatDateWithTimeCell(row, 'fecha_modificacion')

      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <SwitchComponente
              estadoSwitch={row.original.estado}
              titulo={row.original.estado ? 'Activo' : 'Inactivo'}
              setEstadoSwitch={state => {
                if (!hasPermission(PermissionsEnum.api_change_categoria_producto)) return;

                setConfirmDialog({
                  isOpen: true,
                  title: 'Cambiar Estado',
                  subtitle:
                    '¿Está seguro que desea cambiar el estado de esta categoria ?',
                  onConfirm: () => {
                    setConfirmDialogIsOpen(false);
                    updSate.mutate({
                      id: row.original.id_categoria_incidencia!,
                      data: { estado: !!state } as any,
                    });
                  },
                });
              }}
            />
          );
        },
      }
    ],
    []
  );

  return (
    <SingleTableBoxScene title="Categoria Incidente" urlRedirect={`${returnUrl}/crear`} enableRedirect={hasPermission(PermissionsEnum.api_add_categoria_producto)}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="Categoria de Incidencia" cleanFilter={cleanFilter} />

      <GeneralTable<ICategoriaIncidentes>
        columns={columns}
        data={categoriaIncidentesPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={categoriaIncidentesPagingRes?.data?.count}
        // // actions
        //actionsColumnSize={120}
        ///
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        enableManualFiltering={true}
        enableSorting={false}
        //
        enableEditing={false}
        ////
      
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_categoria_producto,
        ])}
        // crud
        onEdit={onEdit}
        canDelete={false}
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_categoria_producto,
        ])}
      />
    </SingleTableBoxScene>
  );
};

export default CategoriaIncidentePage;